import styled, { css } from 'styled-components';
import { device } from '../breakpoints';
import {
    regularBlack,
    playGrey20,
    darkRed,
    regularWhite,
    regularYellow,
    fontWeightBold,
} from '../design-tokens';
import { playFontSize } from '../typography/helpers';
import { PlayBadge } from '../typography/PlayBadge.styles';
import { PLAY_BADGE_COLORS, PLAY_BADGE_SIZE } from './PlayBadge';

const getColor = (color) => {
    switch (color) {
        case PLAY_BADGE_COLORS.GREY:
            return css`
                background: ${playGrey20};
                color: ${regularWhite};
            `;
        case PLAY_BADGE_COLORS.RED:
            return css`
                background: ${darkRed};
                color: ${regularWhite};
            `;
        case PLAY_BADGE_COLORS.YELLOW:
            return css`
                background: ${regularYellow};
                color: ${regularBlack};
            `;
        case PLAY_BADGE_COLORS.WHITE:
            return css`
                background: ${regularWhite};
                color: ${regularBlack};
            `;
        default:
            return css`
                background: ${playGrey20};
                color: ${regularWhite};
            `;
    }
};

const getSize = (size) => {
    switch (size) {
        case PLAY_BADGE_SIZE.SMALL:
            return css`
                ${playFontSize(0.75)}
                padding: 2px;
                top: 2px;
                left: 2px;

                @media ${device.GteSmall} {
                    ${playFontSize(0.75)}
                    padding: 2px;
                }
            `;
        case PLAY_BADGE_SIZE.LARGE:
            return css`
                @media ${device.GteSmall} {
                    ${playFontSize(1.5)}
                    padding: 7px;
                }
            `;
        case PLAY_BADGE_SIZE.XLARGE:
            return css`
                    ${playFontSize(1.3)}
                font-weight: ${fontWeightBold};
                padding: 5px;

                @media ${device.GteLarge} {
                    font-size: 20px;
                }
                `;
        default:
            return css``;
    }
};

export const BadgeWrapper = styled.div`
    ${PlayBadge}
    text-transform: uppercase;
    font-weight: bold;
    padding: 4px 5px;
    z-index: 1;
    display: inline-block;
    line-height: 1;

    @media ${device.GteMedium} {
        padding: 5px 6px;
    }

    ${(props) =>
        props.overlay &&
        css`
            position: absolute;
            top: 5px;
            left: 5px;
        `}

    ${(props) => getColor(props.badgeColor)}
    ${(props) => getSize(props.size)}
`;

export const A11yText = styled.span`
    display: none;
`;
